import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';
import { Router } from '@angular/router';

import { ADMIN_GATE_PERMISSIONS } from '../models/auth-user.model';
import { AuthService } from '../services/auth.service';

/** Allows access when the user holds at least one core Administration permission. */
export function adminGuard(): CanMatchFn {
  return async () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    await auth.waitUntilInitialized();

    if (!auth.isAuthenticated()) {
      return router.createUrlTree(['/login']);
    }

    if (auth.permissions().some((code) => ADMIN_GATE_PERMISSIONS.includes(code))) {
      return true;
    }

    return router.createUrlTree(['/403']);
  };
}
